/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['article-modal.modal .modal-content{width:1000px;box-shadow:none;border:1px solid #e0e0e0;border-radius:4px;overflow:auto}article-modal.modal .scroll-container{overflow:hidden}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovd2FtcDY0L3d3dy9oZWxwZGVzay9jbGllbnQvc3JjL2FwcC9oZWxwLWNlbnRlci9zaGFyZWQvYXJ0aWNsZS1tb2RhbC9hcnRpY2xlLW1vZGFsLmNvbXBvbmVudC5zY3NzLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi93YW1wNjQvd3d3L2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL2hlbHAtY2VudGVyL3NoYXJlZC9hcnRpY2xlLW1vZGFsL2FydGljbGUtbW9kYWwuY29tcG9uZW50LnNjc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// E:/wamp64/www/helpdesk/client/src/$$_gendir/app/help-center/shared/article-modal/article-modal.component.scss.ngstyle.ts